'use client';

import clsx from 'clsx';
import React, { useState } from 'react';

import { Button, Container } from '@/shared';

type PlugProps = React.PropsWithChildren & {
	text: string;
	action: string;
};

export function Plug({ text, action, children }: PlugProps) {
	const [hide, setHide] = useState(true);

	return (
		<>
			{hide && (
				<Container className="absolute inset-0 z-[1] flex w-full flex-col items-center justify-center bg-white/70 pb-11 pt-14 backdrop-blur-[5px]">
					<div></div>
					<div className="max-w-[510px] text-center">
						<p>{text}</p>
						<Button
							onClick={() => setHide(false)}
							className="mx-auto mt-4"
							variant="outline"
							size="sm"
						>
							{action}
						</Button>
					</div>
				</Container>
			)}
			<div className={clsx(hide && 'h-[60vh] overflow-hidden')}>{children}</div>
		</>
	);
}
